export const sqftToAcres = sqft => {
  const dbl = parseFloat(sqft)

  return dbl * 0.0000229568
}

export const centsToDollars = value => value / 100.0
